import { LoginPage as SharedLoginPage } from '@remote-medium/ui';
import { ListChecks, Send, UserCheck } from 'lucide-react';

import { SITE_ORIGIN } from '../../lib/config.ts';
import { authClient } from '../../lib/auth.ts';

export function LoginPage() {
  return (
    <SharedLoginPage
      siteUrl={SITE_ORIGIN}
      heading="Staff sign in"
      intro="For Remote Medium curators. Sign in to the curation dashboard."
      aside={{
        heading: 'The human in the loop.',
        lede: 'Rules rank the pool every night. You decide who is a real fit.',
        card: {
          title: 'Your desk.',
          points: [
            { icon: ListChecks, text: 'Review rankings and their score breakdowns.' },
            { icon: UserCheck, text: 'Confirm fits and ask each candidate first.' },
            { icon: Send, text: 'Send introductions once they say yes.' },
          ],
        },
      }}
      forgotPasswordTo="/forgot-password"
      signIn={async (email, password) => {
        const { error } = await authClient.signIn.email({ email, password });
        return { error: error ? { message: error.message ?? 'Sign-in failed' } : null };
      }}
    />
  );
}
